import { Text, Box, Heading, Flex, Button, Link } from "@chakra-ui/react";
import { format } from "date-fns";
import Head from "next/head";
import { cmsBaseLink } from ".";

export default function HelpPost({
  content,
  title,
  date,
  formattedDate,
}: {
  content: string;
  title: string;
  date: string;
  formattedDate: string;
}) {
  return (
    <>
      <Head>
        <title>{`${title} | Talkio AI`}</title>
        <meta property="og:title" content={title} key="title" />
      </Head>
      <Box minH="800px" bg="white">
        <Flex gap={5} justifyContent={"center"}>
          <Box maxW="1072px">
            <Box mt={8} w="full" maxWidth={"800px"} backgroundColor="#fff" mx={"auto"} px={5}>
              <Heading as="h1" mb={0} fontSize="3xl" lineHeight={1.2}>
                {title}
              </Heading>

              <Text fontSize={"xs"} mt={1} color="brand.gray.400">
                Last updated on <time dateTime={date}>{formattedDate}</time>
              </Text>
              <Box
                mt={5}
                mb={12}
                className="markdown"
                dangerouslySetInnerHTML={{ __html: content }}
              ></Box>
              <Box my="10">
                <Link href="/help" fontSize="sm" textDecoration="underline">
                  Back to all help articles
                </Link>
              </Box>
            </Box>
          </Box>
        </Flex>
      </Box>
    </>
  );
}

export async function getStaticProps({ params }: { params: { id: string } }) {
  const res = await fetch(`${cmsBaseLink}/posts?slug=${params.id}&_embed&per_page=100`);
  const posts = await res.json();
  const post = posts[0];
  const formattedDate = format(new Date(post.date), "MMMM dd, yyyy");

  return {
    props: {
      content: post.content.rendered,
      title: post.title.rendered,
      date: post.date,
      formattedDate,
    },
  };
}

export async function getStaticPaths() {
  // Fetch only help posts for paths
  const res = await fetch(`${cmsBaseLink}/posts?_embed&per_page=100`);
  const posts = await res.json();
  const helpPosts = posts.filter((post: any) =>
    post._embedded?.["wp:term"]?.[0]?.map((category: any) => category.name).includes("help"),
  );
  const paths = helpPosts.map((post: any) => ({
    params: { id: post.slug },
  }));
  return {
    paths,
    fallback: false,
  };
}
